import { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SnackBar from "../../../components/SnackBar";
import { reprocessarSumarizacaoApuracao } from "../../../services/apuracao.service";
import { formatarCnpj } from "../utils";
import styles from "../styles.module.css";

/**
 * Reprocessar por aba (TXM-472/473/601 — concluídos; o bloqueio que mantinha os botões
 * desabilitados em AbaIcms/AbaIcmsSt já foi resolvido). Mesma lógica do
 * ModalReprocessarCat42 (sem "termos de exclusão", só recalcula com os dados atuais),
 * generalizada por título/descrição pra reuso nas abas ICMS e ICMS-ST.
 */
export default function ModalReprocessarAba({
  open,
  onClose,
  onSuccess,
  onError,
  titulo,
  descricao,
  cnpj,
  empresa,
  idApuracao,
}) {
  const [loading, setLoading] = useState(false);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  const handleConfirmar = async () => {
    if (!idApuracao) return;
    setLoading(true);
    try {
      const res = await reprocessarSumarizacaoApuracao(idApuracao, {});
      if (res?.sucesso) {
        onSuccess?.(res.mensagem || "Reprocessamento enfileirado.");
        handleClose();
      } else {
        const msg = res?.mensagem || "Não foi possível reprocessar a apuração.";
        onError?.(msg);
        setObjSnackBar({ type: "error", msg });
      }
    } catch (e) {
      const msg = e?.message || "Erro ao solicitar reprocessamento.";
      onError?.(msg);
      setObjSnackBar({ type: "error", msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className={styles.title}>
            <RefreshIcon sx={{ marginRight: ".5rem" }} />
            {titulo}
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <Typography>
            {formatarCnpj(cnpj)}
            {empresa ? ` — ${empresa}` : ""}
          </Typography>
          <Alert severity="info" sx={{ width: "100%", mt: 2 }}>
            {descricao}
          </Alert>
        </DialogContent>

        <DialogActions className={styles.containerBtn}>
          <Button onClick={handleClose} variant="contained" className={styles.btnCancelar} disabled={loading}>
            Cancelar
          </Button>
          <Button onClick={handleConfirmar} variant="contained" className={styles.btnSalvar} disabled={loading}>
            {loading ? "Enfileirando…" : "Reprocessar"}
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
}
